var _defs, _rect, _rect2, _text, _tspan, _tspan2, _tspan3, _text2, _text3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClock = function SvgClock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "digitalClock",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 132",
    width: 320,
    height: 132,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "clock",
    visibility: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    id: "backgroundGroup"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 300,
    height: 122,
    rx: 16,
    ry: 16,
    fill: "transparent",
    id: "background"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 308,
    height: 120,
    rx: 14,
    ry: 14,
    fill: "none",
    stroke: "#2a2a",
    strokeWidth: 2,
    id: "frame"
  })), /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(160,65)",
    fontFamily: "SFMono-Regular, Menlo, Consolas, 'Liberation Mono', monospace",
    textAnchor: "middle",
    "place-self": "center",
    display: "flex"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "timezone",
    x: 0,
    y: -40,
    dominantBaseline: "middle",
    fontSize: 20,
    fill: "#9CA3AF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "timeGroup",
    transform: "translate(0,0)",
    fontSize: 72,
    fontWeight: 600,
    dominantBaseline: "middle",
    fill: "#E5E7EB",
    display: "flex",
    margin: "auto"
  }, /*#__PURE__*/React.createElement("text", {
    id: "time",
    x: 0,
    y: 5,
    dominantBaseline: "middle",
    textAnchor: "middle",
    style: {
      fontVariantNumeric: "tabular-nums",
      kerning: "auto",
      letterSpacing: "normal"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "hour"
  }, "9")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "colon",
    dx: "-0.1em"
  }, ":")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "minutes",
    dx: "-0.1em"
  }, "07"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "ampm",
    x: 120,
    y: 5,
    fontSize: 28,
    fontWeight: 400,
    fill: "#9CA3AF",
    textAnchor: "start"
  }, "am"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "date",
    x: 0,
    y: 42,
    dominantBaseline: "middle",
    fontSize: 20,
    fill: "#9CA3AF"
  }, "\n          Aug 28, 2025\n        "))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";